import { Component, NgZone, OnInit } from '@angular/core';

import { MainService } from '../main.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import jwt_decode from 'jwt-decode';

// import { NgxSpinnerService } from "ngx-spinner";
// import { RegisterService } from 'src/app/services/register.service';


// import { environment } from '../../../environments/environment';
declare var google: any;


declare var $: any;

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {
  nation = [{ id: 'INDIVIDUAL', value: "IND" }, { id: 'ORGANISATION', value: "ORG" }]
  purpose = [{ id: 'PERSONAL' }, { id: 'BUSINESS' }]
  cat = [{ id: 'GEN' }, { id: 'OBC' }, { id: 'SC' }, { id: 'ST' }]

  constructor(private router: Router, private reg: MainService, public zone: NgZone) { }
  Obj = {}
  m_otp;
  e_otp;
  b_acct_id;
  obj = {}
  party_type='IND'
  currentOrigin: any
  loginpass_flag: any
  solnHostUrl: any
  pubHostUrl: any
  fpath: any
  urlPassAcctID: any
  urlPassReturnfpath: any
  jwtToken: any;
  login: any = {


  };
  async ngOnInit() {
    this.currentOrigin = location.protocol + '//' + location.hostname;
    this.loginpass_flag = this.reg.loginWithPassword;
    await this.getAuthConfig()
    await this.getHostFpath();
    this.urlPassAcctID = this.reg.urlPassAcctID;
    this.urlPassReturnfpath = this.reg.urlPassReturnfpath;
    await this.getCurrentLegalEntity()
    console.log(location.origin);
    


  }
  current_LE = []
  ind_current_LE = []
  org_current_LE = []
  emailFlag=false;
  phoneFlag=false
  goaFlag=false
  emailRegFlag=false;
  orgAllowed=false
  async getAuthConfig(){
    console.log(this.reg.auth_validation);
    this.emailFlag=false;
    this.phoneFlag=false
    this.goaFlag=false;
    this.emailRegFlag=false;
    this.orgAllowed=false
    if(this.reg.auth_validation['E-KEY']){
      this.emailFlag=true;
      this.emailRegFlag=true;
    }
    if(this.reg.auth_validation['GOA']){
      this.emailFlag=true;
      this.goaFlag=true;
      await this.getGoogleSignUp()
    }
    if(this.reg.auth_validation['P-KEY']){
      this.phoneFlag=true;
    }
    if(this.reg.auth_validation['OTP']){
      this.phoneFlag=true;
    }
    if(this.reg.auth_validation['org_allowed']){
      this.orgAllowed=true;
    }
    console.log(this.emailFlag,this.phoneFlag);
    
    
  }

  getHostFpath() {

    for (const hostapp of this.reg.hostWithReturnUrl) {
      if (hostapp['name'] == 'solnAdmin') {
        this.solnHostUrl = hostapp['host'];
      }
      if (hostapp['name'] == 'erppublic') {
        this.pubHostUrl = hostapp['host'];
      }
      if (this.currentOrigin == hostapp['host']) {
        this.fpath = hostapp['fpath'];
      }
    }
  }


  async getCurrentLegalEntity() {
    this.current_LE = []
    this.ind_current_LE = []
    this.org_current_LE = []
    let obj = {}
    //this.spinner.show()
    //   console.log(this.reg.getBillingAcctId())
    var resp = await this.reg.getCurrentLegalEntity(JSON.stringify(obj));
    console.log(resp);
    if (resp['error'] == false) {
      //this.spinner.hide()
      console.log(resp, 'legal Entity');
      this.current_LE = resp['data']
      for (let i = 0; i < this.current_LE.length; i++) {
        if (this.current_LE[i]['party_type'] == 'IND') {

          this.ind_current_LE.push(this.current_LE[i])
        } else {
          this.org_current_LE.push(this.current_LE[i])
        }
      }
    } else {
      //this.spinner.hide()
      Swal.fire("Error", "..Error while getting current Legal Entity", 'error');
    }
  }

  async createLegalEntity() {
    let obj1 = {}
    obj1["party_name"] = this.Obj["party_name"]
    obj1["legal_name"] = this.Obj["party_name"]
    obj1["party_dob"] = this.Obj["dob"]
    obj1['contact_email'] = this.Obj['email']
    obj1['contact_phone'] = this.Obj['phone_no']
    if(this.Obj['nationality']==undefined || this.Obj['nationality']==null){
      this.Obj['nationality']='IND'
    }
    obj1['party_type'] = this.Obj['nationality']
     obj1['ident_verify_secret']='User@1'
    // obj1['b_acct_id'] = this.reg.getBillingAcctId()
    // obj1['party_type'] = 'IND'
    obj1['valid_upto'] = '2038-01-11 11:00:00.000000'
    console.log(obj1)
    let resp = await this.reg.createLegalEntity(obj1)
    console.log(resp)
    if (resp['error'] == false) {
      await this.getCurrentLegalEntity()
      this.obj['le_id'] = resp['data']
      this.Obj['le_id'] = resp['data']
      console.log(this.Obj);
      console.log(this.obj);

      for (let i = 0; i < this.ind_current_LE.length; i++) {
        if (this.ind_current_LE[i]['le_id'] == this.obj['le_id']) {
          console.log("inside condition");

          this.obj['le_id'] = this.ind_current_LE[i]['le_id']
          this.obj['party_email'] = this.ind_current_LE[i]['contact_email']
          this.obj['party_father_or_husband_name'] = null
          this.obj['party_name'] = this.obj['party_name']
          break;
        }
      }

      Swal.fire('Success', 'Registered Successfully', 'success')
     // $('#myModalregverify').modal('hide');
      if(this.Obj['email']!=null && this.Obj['email']!=undefined && this.Obj['email']!="" ){
        // await this.sendMail(this.Obj['email'],obj1['ident_verify_secret'],this.Obj["party_name"])
      }
      await this.loginFinal()
    }
    else {
      Swal.fire('Error', resp['data'], 'error')
    //  $('#myModalregverify').modal('hide');
    }
  }
  async sendMail(mail,pass,name){
    let reqObj=new Object()
    reqObj['name']=name
    reqObj['recevier_email_id']=mail
    reqObj['subject']="Reset Password"
    reqObj['pass']=pass
    let url=location.origin + '/#/login'
    reqObj['url']=url
    var resp = await this.reg.sendmail(reqObj);
    console.log(resp);
    if (resp['error'] == false) {
      //this.spinner.hide()
     
      }
     else {
      //this.spinner.hide()
      Swal.fire("Error", "..Error while sending mail", 'error');
    
  }


  }
  async regitser() {
    console.log("Inside Register");
    let create_le_flag = true

    if (this.Obj == null || this.Obj == undefined) {
      Swal.fire('Please Enter required Field', '', 'warning')
      return
    }

    if ((this.Obj['email'] == null || this.Obj['email'] == undefined) && this.emailRegFlag) {
      Swal.fire('Please Enter email.', '', 'warning')
      return
    }
    if ((this.Obj['phone_no'] == null || this.Obj['phone_no'] == undefined)  && this.phoneFlag) {
      Swal.fire('Please Enter phone no.', '', 'warning')
      return
    }
    // if(this.Obj['password']==null||this.Obj['password']==undefined){
    //   Swal.fire('Please Enter password.', '', 'warning')
    //   return
    // }
    // if(this.Obj['v_password']==null||this.Obj['v_password']==undefined){
    //   Swal.fire('Please Enter confirm password.', '', 'warning')
    //   return
    // }
    // if (this.Obj['dob'] == null || this.Obj['dob'] == undefined) {
    //   Swal.fire('Please Enter Date of birth.', '', 'warning')
    //   return
    // }
    // if (this.Obj['nationality'] == null || this.Obj['nationality'] == undefined) {
    //   Swal.fire('Please Enter party type.', '', 'warning')
    //   return
    // }

    if (this.Obj['email'] !== null && this.Obj['email'] !== undefined) {
      let result = this.doValidateemail(this.Obj['email'])
      console.log(result)
      if (result == false) {
        Swal.fire('Email Is Not Valid', '', 'warning')
        return
      }
    }
    if (this.Obj['phone_no'] !== null && this.Obj['phone_no'] !== undefined) {
      let result = this.doValidatephone(this.Obj['phone_no'])
      console.log(result)
      if (result == false) {
        Swal.fire('Phone no. Is Not Valid', '', 'warning')
        return
      }
    }

    if (this.Obj['dob'] != null || this.Obj['dob'] != undefined) {
      var today = new Date();
      var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
      console.log('party', date)
      let age = await this.dermineage(this.Obj['dob'])
      console.log(age, 'age')
      if (age < 18) {

        Swal.fire('Error...', 'You Are Under Age Of 18', 'error')
        return
      }
    }
    this.Obj['user_id'] = this.Obj['phone_no']


    // for (let i = 0; i < this.ind_current_LE.length; i++) {

    //   if (this.ind_current_LE[i]['phone_no'] == this.Obj['phone_no']) {
    //     create_le_flag = false
    //     this.Obj['le_id'] = this.ind_current_LE[i]['le_id']
    //     this.Obj['party_email'] = this.ind_current_LE[i]['contact_email']
    //     this.Obj['party_father_or_husband_name'] = null
    //     this.Obj['party_name'] = this.Obj['party_name']
    //     break;
    //   }
    // }
    if (create_le_flag == true) {
      console.log("yoyo buntai rapper");
      // $('#myModalregverify').modal('show');
      await this.finalregister()

    }


  }
  close() {
    $('#myModalregverify').modal('hide');

  }
  async finalregister() {
    await this.createLegalEntity()


  }
  flag1 = 0
  mobile_otp() {
    this.m_otp = ''
    this.flag1 = 0


    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if (phoneno.test(this.Obj['phone_no'])) {
      this.m_otp = 123456
      this.flag1 = 1
      Swal.fire('Otp Generated Successfully', '', 'success')


    } else {
      Swal.fire('Mobile Number Is Not Valid', '', 'warning')

    }
  }

  flag = 0
  email_otp() {
    this.flag = 0
    //this.spinner.show()
    this.e_otp = ''

    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    //var address = document.getElementById[email].value;
    if (reg.test(this.Obj['email']) == false) {
      Swal.fire('Email Is Not Valid', '', 'warning')
      //this.spinner.hide()
    } else {
      Swal.fire('Otp Generated Successfully', '', 'success')
      this.e_otp = 123456
      this.flag = 1
      //this.spinner.hide()
    }
  }
  adhar = 0;
  adhar_verify() {
    this.adhar = 0;
    let regexp = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;

    if (regexp.test(this.Obj['adhar_no'])) {
      this.adhar = 1
      // Swal.fire('good')
    }
    else {
      Swal.fire('Please Enter A Valid Adhar Number', '', 'info')
    }
  }
  // Auctionhome() {
  //   this.router.navigate(['/prop/auction/auction-home'])

  // }

  // ------------sam   Code -----------------//
  regflag = false
  legaldata = {}
  detail = false
  loginid
  logindatail = []
  dermineage(dob) {
    var today = new Date();
    var birthDate = new Date(dob);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }
  validateEmail(email) { //Validates the email address
    var emailRegex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return emailRegex.test(email);
  }

  validatePhone(phone) { //Validates the phone number
    var phoneRegex = /^(\+91-|\+91|0)?\d{10}$/; // Change this regex based on requirement
    return phoneRegex.test(phone);
  }
  doValidatephone(loginid: string): boolean {
    if (!this.validatePhone(loginid)) {
      return false;
    }
    return true; 
  }
  
  doValidateemail(loginid: string): boolean {
    if (!this.validateEmail(loginid)) {
      return false;
    }
    return true; 
  }
  
  dataflag = false;
  async getCurrentLegalEntitybyid() {
    this.Obj = {}
    this.dataflag = false;
    //  console.log(this.reg.getBillingAcctId())
    let obj = {}
    //   obj['b_acct_id'] = this.reg.getBillingAcctId()
    let login = isNaN(this.loginid)
    console.log(login)

    if (!isNaN(this.loginid)) {
      if(!this.phoneFlag){
        Swal.fire('Please Enter Your Email', '', 'warning')
        return
        
      }
      let result = this.doValidatephone(this.loginid)
      console.log(result)
      if (result == false) {
        Swal.fire('Phone Is Not Valid', '', 'warning')
        return
      }
      else {
        obj['phone_no'] = this.loginid
        //this.spinner.show()
        let resp = await this.reg.getCurrentLegalEntity(JSON.stringify(obj));
        console.log(resp)
        //this.spinner.hide()
        if (resp['error'] == false && resp['data'].length > 0) {



          console.log("legal", resp['data'])
          this.legaldata = resp['data'][0]
          console.log(this.legaldata)
          this.detail = true


        }
        else if (resp['error'] == false && resp['data'].length == 0) {
          Swal.fire('user not exist', '', 'info')
          this.Obj['phone_no'] = this.loginid
          this.regflag = true
          await this.getGoogleSignUp()
          return
        }

      }


    } else if (isNaN(this.loginid)) {
      let result = this.doValidateemail(this.loginid)
      console.log(result)
      if (result == false) {

        Swal.fire('Email Is Not Valid', '', 'warning')
        return
      } else {
        obj['contact_email'] = this.loginid
        //this.spinner.show()
        let resp = await this.reg.getCurrentLegalEntity(JSON.stringify(obj));
        console.log(resp);
        //this.spinner.hide()
        if (resp['error'] == false && resp['data'].length > 0) {


          console.log("legal", resp['data'])
          this.legaldata = resp['data'][0]
          console.log(this.legaldata)
          this.detail = true



        } else if (resp['error'] == false && resp['data'].length == 0) {
          Swal.fire('user not exist', '', 'info')
          this.Obj['email'] = this.loginid
          this.regflag = true
          await this.getGoogleSignUp()
        }
      }

    }
  }
  lclsession
  lcllocal
  gotoLogin(){
    this.router.navigate(['/login'])
  }

  async loginFinal() {
    this.reg.getRetuenUrlWithAcctID('');
    this.zone.run(() => {
      this.router.navigate(['/login'])
    });

    console.log(this.lcllocal, this.lclsession, 'gugui');
    let interval = setInterval(() => {
      this.lclsession = JSON.parse(sessionStorage.getItem('erpUser'))
      this.lcllocal = JSON.parse(sessionStorage.getItem('erpUser'))

      if (this.lclsession != null) {

        clearInterval(interval);
      }
    }, 5000)


  }
  cancel() {
    this.router.navigate([this.fpath])

  }
  async getGoogleSignUp() {
    {
      let googleScript = document.createElement('script');
      googleScript.src = 'https://accounts.google.com/gsi/client';
      document.head.appendChild(googleScript);
      setTimeout(async () => {
        google.accounts.id.initialize({
          client_id: "317079145994-njhoq3f8dgj2kjj5jjr1m4ksts5if9g8.apps.googleusercontent.com",
          callback: await this.handleCredentialResponse.bind(this),
        });
        google.accounts.id.renderButton(
          document.getElementById("signin_button"),
          { type: "standard", theme: "filled_blue", size: "large", text: "signup_with" }

        );

      }, 100);

    }
  }
  googleUser = {}
  async handleCredentialResponse(response: any) {
    this.googleUser = {}
    console.log(response, 'handleCredentialResponse');
    // console.log(response.credential);
    var responsePayload: any = jwt_decode(response.credential);
    console.log(responsePayload);
    this.googleUser = responsePayload


    console.log("ID: " + responsePayload.sub);
    console.log('Full Name: ' + responsePayload.name);
    console.log('Given Name: ' + responsePayload.given_name);
    console.log('Family Name: ' + responsePayload.family_name);
    console.log("Image URL: " + responsePayload.picture);
    console.log("Email: " + responsePayload.email);
    await this.checkForMailExistsorNot()
    // this.regularFunction()
  }
  async checkForMailExistsorNot() {
    let checkObj = new Object()
    checkObj['contact_email'] = this.googleUser['email']
    //this.spinner.show()
    let resp = await this.reg.getCurrentLegalEntity(JSON.stringify(checkObj));
    console.log(resp);
    //this.spinner.hide()
    if (resp['error'] == false && resp['data'].length > 0) {
      Swal.fire('Email Already Registered', '', 'info')
      await this.socialSignIn()
    } else if (resp['error'] == false && resp['data'].length == 0) {


      await this.createIdentityForgoogleSignup()
    }
  }
  async createIdentityForgoogleSignup() {
    let obj1 = {}
    obj1["party_name"] = this.googleUser['name']
    obj1["legal_name"] = this.googleUser['name']
    obj1["party_dob"] = null
    obj1['contact_email'] = this.googleUser['email']
    obj1['contact_phone'] = null
    
    obj1['party_type'] = 'IND'
    obj1['valid_upto'] = '2038-01-11 11:00:00.000000'
    console.log(obj1)
    let resp = await this.reg.createLegalEntity(obj1)
    console.log(resp)
    if (resp['error'] == false) {
      Swal.fire('Success', 'Registered Successfully', 'success')
      await this.socialSignIn()
    }
    else {
      Swal.fire('Error', resp['data'], 'error')

    }
  }
  audit_info_obj = {}
  setpartydtls = {}
  async socialSignIn() {
    var obj = new Object();
    obj['ident_to_verify'] = this.googleUser['email']
    obj['ident_verify_method'] = 'GOA';

    this.audit_info_obj['login_id'] = this.googleUser['email']
    this.audit_info_obj['password'] = null;
    this.audit_info_obj['login_type'] = 'GOA';


    var resp = await this.reg.loginERP(obj);
    if (resp['error'] == false && resp['data'].length > 0) {
      this.setpartydtls = resp['data'][0]

      await this.finalLoginforNoAccount()

    } else if (resp['data'].length == 0) {
      this.audit_info_obj['status'] = 'FAIL';
      this.audit_info_obj['user_id'] = '';
      this.audit_info_obj['message'] = 'failed to login account';

      await this.audit_insert(this.audit_info_obj);
      Swal.fire('Oops...', 'Failed to login account', 'error');
    } else {
      this.audit_info_obj['status'] = 'FAIL';
      this.audit_info_obj['user_id'] = '';
      this.audit_info_obj['message'] = resp['data'];

      await this.audit_insert(this.audit_info_obj);
      Swal.fire('Error...', resp['data'], 'error');
    }



  };
  async finalLoginforNoAccount() {
    this.login['party_name'] = this.setpartydtls['legal_name'];
    this.login['party_dob'] = this.setpartydtls['party_dob'];
    this.login['party_type'] = this.setpartydtls['party_type'];
    this.login['contact_phone'] = this.setpartydtls['phone_no'];
    this.login['user_id'] = this.setpartydtls['le_id'];
    this.login['identity_id'] = this.setpartydtls['identity_id']
    this.login['le_id'] = this.setpartydtls['le_id'];
    this.login['contact_email'] = this.setpartydtls['contact_email'];

    this.audit_info_obj['status'] = 'PASS';
    this.audit_info_obj['user_id'] =
      'User ID:' +
      this.setpartydtls['le_id']

    this.audit_info_obj['message'] = 'Logged In Successfully!';

    await this.audit_insert(this.audit_info_obj);
    Swal.fire('Success', 'Logged In Successfully! ', 'success');

    /// jwt token generated
    const { ident_verify_secret, ...filterdata } = this.login;
    var resp = await this.reg.generateTokens(filterdata);
    this.jwtToken = resp['jwt'];

    //storing svm_jwt and erpUser into session storage
    sessionStorage.setItem('erpUser', JSON.stringify(filterdata));
    sessionStorage.setItem('svm_jwt', JSON.stringify(this.jwtToken));

    if (this.urlPassReturnfpath == undefined || this.urlPassReturnfpath == null || this.urlPassReturnfpath == "") {
      console.log('came to this')
      console.log(this.fpath);


      this.zone.run(() => {
        this.router.navigate(['./' + this.fpath]);
      });

    } else {
      this.zone.run(() => {
        this.router.navigate(['./' + this.urlPassReturnfpath]);
      });

    }



  }
  async audit_insert(audit_info_obj: any) {
    var resp = await this.reg.createloginInfo(audit_info_obj);
  }





}
